import { render, staticRenderFns } from "./BaseIntegrationMenu.vue?vue&type=template&id=7f492e5b&scoped=true"
import script from "./BaseIntegrationMenu.vue?vue&type=script&lang=js"
export * from "./BaseIntegrationMenu.vue?vue&type=script&lang=js"
import style0 from "./BaseIntegrationMenu.vue?vue&type=style&index=0&id=7f492e5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f492e5b",
  null
  
)

export default component.exports